import React from "react";
import { Button } from "@material-ui/core";
import "./styles.scss";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListMembers from "../../../services/list-member";
import { useSelector } from "react-redux";
import stringJp from '../../../constants/stringJP';

const DeleteMember = (props) => {
    /* eslint eqeqeq: 0 */
    const { dataMember, index, setDataMember, count, setCount } = props;
    const [open, setOpen] = React.useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const account_id = localStorage.getItem('account_id');
    const security_key = localStorage.getItem('security_key');

    const handleClickOpen = () => {
        setOpen(true);
    };

    const dataUser = useSelector(state => state.chart.dataChart);

    let ischeckBirthUser;

    const handleRemove = () => {
        if (dataUser == undefined) {
            ischeckBirthUser = 1;
            setOpen(false);
        } else {
            dataMember.splice(index, 1);
            const params = {
                data: dataMember.filter((item, index) => index !== 0),
                account_id: account_id,
                security_key: security_key,
                gender: dataUser?.user?.gender,
                birthday: dataUser?.user?.birthday,
            };
            ListMembers.postDataMember(
                params,
                () => {
                    setDataMember([...dataMember]);
                    setCount(count + 1);
                    setOpen(false);
                },
                () => {
                    setOpen(false);
                    setOpenDelete(true);
                }
            );
        }

    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };
    
    return (
        <div>
            <div className="delete-member">
                <Button
                    variant="contained"
                    component="span"
                    className="button-delete"
                    onClick={handleClickOpen}
                >
                    <p>ー</p>
                </Button>
            </div>
            <Dialog
                open={openDelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="dialog-delete-ok"
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title-delete">{"例外エラーが発生しました。"}</DialogTitle>
                <hr style={{ margin: 0 }} />
                <DialogActions className="dialog-actions-delete">
                    <Button onClick={handleCloseDelete} className="button-ok">
                        <p>{stringJp.delete_dialog_button}</p>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="dialog-delete"
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title"> {ischeckBirthUser == 1 ? "birthdayは必須です。" : "入力内容を取り消しますか？"}</DialogTitle>
                <DialogActions className="dialog-actions">
                    <Button onClick={handleRemove} variant="contained" component="span" className="submit">
                        <p>{stringJp.delete_submit_button}</p>
                    </Button>
                    <Button onClick={handleClose} variant="contained" component="span" className="cancel">
                        <p>{stringJp.delete_cancel_button}</p>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export { DeleteMember };
